import React from 'react';
import LoadingIndicator from 'generic/LoadingIndicator.react';

export class Loading extends React.Component {
  render() {
    return (
      <div>
        <LoadingIndicator />
      </div>
    );
  }
}
